import { BehaviorSubject } from 'rxjs'
import { createMapSubjectValueHook } from 'src/utils/rx'

const $itemLiked = new BehaviorSubject<Record<string, boolean>>({})

export const useItemLiked = createMapSubjectValueHook($itemLiked, false)

const $itemLikedCount = new BehaviorSubject<Record<string, number>>({})

export const useItemLikedCount = createMapSubjectValueHook($itemLikedCount, 0)
